/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import Filter, { FilterableProps } from '../Filter'
import useMandateTypeOptions from '../mandate/useMandateTypeOptions'
import useArrayFilter from '../../../../client/js/hooks/useArrayFilter'
import { useIntl } from 'react-intl'
import { Checkbox, Radio } from '@mantine/core'

function MandateTypeFilter (props: FilterableProps<string[]>) {
  const { onChange, value } = props
  const intl = useIntl()
  const options = useMandateTypeOptions()
  const [array, handleChange] = useArrayFilter(value, onChange)
  return (
    <Filter>
      <Radio
        checked={array.length === 0}
        id="mandate_type_all_filter"
        label={intl.formatMessage({
          id: 'all',
          defaultMessage: 'Tout'
        })}
        name="type"
        onChange={(event) => {
          if (event.target.checked) {
            onChange(event.target.name, undefined)
          }
        }}
        value=""
      />
      {options.map((option) => (
        <Checkbox
          key={option.value}
          checked={array.includes(option.value)}
          label={option.label}
          name="type"
          onChange={handleChange}
          value={option.value}
        />
      ))}
    </Filter>
  )
}

export default MandateTypeFilter
